import clsx from 'clsx';
import React, { memo } from 'react';

const HeaderColumn = ({ children, className }) => {
  return <div className={clsx('header-column', className)}>{children}</div>;
};

export default memo(HeaderColumn);
